import type { ComposerUndoResponse } from "@bash/shared";
import { apiUrl } from "@/lib/api/base";
import { getRequiredAccessToken } from "@/lib/api/client";

/** The chip's own line when the route could not be reached; the word still
 *  works. Vestra, never Bash: the server's own undo sentences say Vestra
 *  (panels/words.ts) and both land in the same span of the card. */
export const UNDO_FAILED =
  "That did not go through. Say undo to Vestra instead.";

/**
 * POST /api/composer/runs/:runId/undo (composer panels, spec 2026-09-19 §3.3):
 * the Undo chip's one post. The route runs the SAME inverse "undo" by word
 * runs, once, and answers the words to show; a refusal is words too.
 */
export async function undoRunApi(runId: string): Promise<ComposerUndoResponse> {
  const token = await getRequiredAccessToken("undoRun: no Supabase session");
  const res = await fetch(
    apiUrl(`/api/composer/runs/${encodeURIComponent(runId)}/undo`),
    {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      credentials: "include",
    }
  );
  let body: Partial<ComposerUndoResponse> = {};
  try {
    body = (await res.json()) as Partial<ComposerUndoResponse>;
  } catch {
    /* a body-less refusal: the fallback below */
  }
  return {
    ok: res.ok && body.ok === true,
    words: typeof body.words === "string" ? body.words : UNDO_FAILED,
  };
}
